import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SmallDesktop } from '@hellodarwin/core/lib/components/common/Media';
import Typography from '@hellodarwin/core/lib/components/common/typography';
import { lazy, useMemo } from 'react';
import { useTheme } from 'styled-components';
import { useRichText } from '../../../../utils/richText';
import CTAsList from '../../../common/CTAsList';
import ContentfulImage from '../../../common/Image';
import { StepCardBody, StepCardContainer, StepCardCover, StepNumberContainer, } from './styles';
const Numbers = {
    1: lazy(() => import(`./step-numbers/StepNumber1`)),
    2: lazy(() => import(`./step-numbers/StepNumber2`)),
    3: lazy(() => import(`./step-numbers/StepNumber3`)),
    4: lazy(() => import(`./step-numbers/StepNumber4`)),
    5: lazy(() => import(`./step-numbers/StepNumber5`)),
};
const StepCard = (props) => {
    var _a;
    const { title, bodyLong, image, size = 'medium', CTAs, isRow, stepNumber, } = props;
    const theme = useTheme();
    const links = useMemo(() => CTAs === null || CTAs === void 0 ? void 0 : CTAs.map((cta) => (Object.assign(Object.assign({}, cta.fields), { size: 'small', theme: 'white_1' }))), [CTAs]);
    const mainCTA = useMemo(() => links === null || links === void 0 ? void 0 : links[0], [links]);
    const bodyContent = useRichText(bodyLong);
    const titleSize = useMemo(() => (size === 'medium' ? 'h4' : 'h5'), [size]);
    const StepNumber = useMemo(() => {
        var _a;
        if (stepNumber == null)
            return null;
        return (_a = Numbers[stepNumber]) !== null && _a !== void 0 ? _a : null;
    }, [stepNumber]);
    return (_jsxs(StepCardContainer, { "$withCta": !!mainCTA, "$hoverable": !!mainCTA, "$isRow": isRow, children: [!!image && (_jsxs(StepCardCover, { style: {
                    padding: 24,
                    position: 'relative',
                    zIndex: 2,
                }, children: [stepNumber != null && (_jsx(StepNumberContainer, { children: StepNumber && _jsx(StepNumber, { width: 64, height: 64 }) })), _jsx(ContentfulImage, { loading: "lazy", asset: image, alt: ((_a = image.fields) === null || _a === void 0 ? void 0 : _a.title) || '', style: {
                            maxWidth: '100%',
                            maxHeight: '100%',
                        } })] })), _jsxs(StepCardBody, { children: [_jsxs(Typography.Title, { level: 3, elementTheme: titleSize, style: {
                            position: 'relative',
                        }, children: [_jsx(SmallDesktop, { direction: "up", children: isRow && (_jsx("span", { style: {
                                        position: 'absolute',
                                        borderBottom: `1px solid ${theme.colors.grey_1}`,
                                        width: 45,
                                        right: 'calc(100% + 15px)',
                                        top: '50%',
                                    } })) }), title] }), !!bodyContent && _jsx(Typography, { children: bodyContent }), _jsx(CTAsList, { CTAs: links, nested: true })] })] }));
};
export default StepCard;
